import React from 'react';

export const homeRoute = [
  {
    path: '/home/homePage',
    component: React.lazy(() => import('@/views/system/homePage/newIndex')),
    meta: {
      title: '推荐'
    }
  },
  {
    path: '/home/SvipMember',
    component: React.lazy(() => import('@/views/system/svipMember')),
    meta: {
      title: 'SVIP成长体系',
      crumbs: 1000
    }
  },
  {
    path: '/home/newSuit',
    component: React.lazy(() => import('@/views/system/newSuit')),
    meta: {
      title: '新服'
    }
  },
  {
    path: '/home/lookingSuit',
    component: React.lazy(() => import('@/views/system/lookingSuit')),
    meta: {
      title: '找服'
    }
  },
  {
    path: '/home/ranking',
    // component: React.lazy(() => import('@/views/system/ranking')),
    component: React.lazy(() => import('@/views/system/rankings')),
    meta: {
      title: '排行'
    }
  },
  {
    path: '/home/transaction',
    component: React.lazy(() => import('@/views/system/tradingReconsituition')),
    meta: {
      title: '交易行'
    },
    children: [
      {
        path: '/home/transaction/helpCenter',
        component: React.lazy(() => import('@/views/system/transaction/helpCenter')),
        meta: {
          title: '交易行-帮助中心'
        }
      },
      {
        path: '/home/transaction/appoint',
        component: React.lazy(() => import('@/views/system/transaction/appoint')),
        meta: {
          title: '交易行-指定我'
        }
      },
      {
        path: '/home/transaction/myBox',
        component: React.lazy(() => import('@/views/system/transaction/myBox')),
        meta: {
          title: '交易行-我的'
        }
      },
      {
        path: '/home/transaction/seller',
        component: React.lazy(() => import('@/views/system/transaction/seller')),
        meta: {
          title: '交易行-卖家货架'
        }
      },
      {
        path: '/home/transaction/confirmOrder',
        component: React.lazy(() => import('@/views/system/transaction/placeOrder/confirmOrder')),
        meta: {
          title: '交易行-确认订单'
        }
      },
      {
        path: '/home/transaction/confirmPurchase',
        component: React.lazy(() => import('@/views/system/transaction/placeOrder/confirmPurchase')),
        meta: {
          title: '交易行-订单支付'
        }
      },
      {
        path: '/home/transaction/myPurchase',
        component: React.lazy(() => import('@/views/system/transaction/myBox/purchase')),
        meta: {
          title: '交易行-我要买'
        }
      },
      {
        path: '/home/transaction/shoppingCart',
        component: React.lazy(() => import('@/views/system/transaction/ShoppingCart')),
        meta: {
          title: '交易行-确认订单'
        }
      }
    ]
  },
  {
    path: '/home/task',
    component: React.lazy(() => import('@/views/system/task/missionHall')),
    meta: {
      title: '任务'
    },
    children: [
      {
        path: '/home/task/myTask',
        component: React.lazy(() => import('@/views/system/task/myTask')),
        meta: {
          title: '我的任务'
        }
      }
    ]
  },
  {
    path: '/home/member',
    component: React.lazy(() => import('@/views/system/member')),
    meta: {
      title: '会员'
    }
  },
  {
    path: '/home/proxyTraining',
    component: React.lazy(() => import('@/views/system/proxyTraining')),
    meta: {
      title: '代练'
    }
  },
  {
    path: '/home/demo',
    component: React.lazy(() => import('@/views/Demo')),
    meta: {
      title: 'Demo'
    }
  },
  {
    path: '/home/community',
    component: React.lazy(() => import('@/views/community/homePage')),
    meta: {
      title: '社区'
    },
    children: [
      {
        path: '/home/community/feedback',
        component: React.lazy(() => import('@/views/community/feedback')),
        meta: {
          title: '反馈中心'
        }
      }
    ]
  },
  {
    path: '/home/iframeBox',
    component: React.lazy(() => import('@/views/system/iframeBox')),
    meta: {
      title: '活动页'
    }
  },
  {
    path: '/home/iframeBoxTwo',
    component: React.lazy(() => import('@/views/system/iframeBox')),
    meta: {
      title: '活动页'
    }
  },
  {
    path: '/home/raffle',
    component: React.lazy(() => import('@/views/system/raffle')),
    meta: {
      title: '抽奖'
    },
    children: [
      {
        path: '/home/raffle/detail',
        component: React.lazy(() => import('@/views/system/raffle/raffleDetail')),
        meta: {
          title: '抽奖详情'
        }
      }
    ]
  },
  {
    path: '/home/pass',
    component: React.lazy(() => import('@/views/system/pass/home')),
    meta: {
      title: '通行证'
    },
    children: [
      {
        path: '/home/pass/detail',
        component: React.lazy(() => import('@/views/system/pass/passDetail')),
        meta: {
          title: '通行证详情'
        }
      }
    ]
  },
  {
    path: '/home/searchDetail',
    component: React.lazy(() => import('@/views/system/searchDetail')),
    meta: {
      title: '搜索页'
    }
  },
  {
    path: '/home/community/searchDetail',
    component: React.lazy(() => import('@/views/community/SearchDetail')),
    meta: {
      title: '搜索页'
    }
  }
];
